import React, { useEffect, useState } from "react";
import ClientLayout from "../../../components/client/ClientLayout";
import { clientApi } from "../../../api";

/**
 * Venue-admin controls for which optional portal features/menus show for this
 * venue. Mirrors the platform-admin toggles (admin venue → General) — both
 * write the same `venues.*_enabled` columns. Start with digital membership
 * (Litecard); add more feature toggles here as they're introduced.
 */
export default function PortalFeatures() {
  const [venue, setVenue]               = useState(null);
  const [digitalPasses, setDigitalPasses] = useState(true);
  const [genderField, setGenderField]     = useState(true);
  const [ga4, setGa4]                     = useState("");
  const [pixel, setPixel]                 = useState("");
  const [saving, setSaving]             = useState(false);
  const [msg, setMsg]                   = useState("");
  const [err, setErr]                   = useState("");

  useEffect(() => {
    clientApi.getVenue()
      .then((v) => { setVenue(v); setDigitalPasses(v.digital_passes_enabled !== false); setGenderField(v.gender_field_enabled !== false); setGa4(v.ga4_measurement_id || ""); setPixel(v.meta_pixel_id || ""); })
      .catch((e) => setErr(e.message));
  }, []);

  async function save() {
    setSaving(true); setMsg(""); setErr("");
    try {
      await clientApi.updateVenue({ digital_passes_enabled: digitalPasses, gender_field_enabled: genderField, ga4_measurement_id: ga4.trim() || null, meta_pixel_id: pixel.trim() || null });
      setMsg("Saved. Menu changes apply as you move around the portal.");
    } catch (e) { setErr(e.message); }
    setSaving(false);
  }

  return (
    <ClientLayout>
      <div className="venues-page-header">
        <div>
          <h1>Portal Features</h1>
          <p className="page-subtitle">Show or hide optional portal features for this venue</p>
        </div>
      </div>

      {err && <div className="toast toast-error"   style={{ marginBottom: "0.75rem" }}>{err}</div>}
      {msg && <div className="toast toast-success" style={{ marginBottom: "0.75rem" }}>{msg}</div>}

      <div className="settings-card" style={{ maxWidth: 720 }}>
        <div className="settings-card-header">
          <h3>Digital membership</h3>
          <p>
            Digital wallet passes (Litecard). When off, the <strong>Digital Passes</strong> and{" "}
            <strong>Digital Card</strong> menus are hidden for this venue and the member Passes tab disappears.
          </p>
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer", fontWeight: 600 }}>
          <input
            type="checkbox"
            checked={digitalPasses}
            onChange={(e) => setDigitalPasses(e.target.checked)}
            disabled={!venue}
          />
          <span>Enable digital membership for this venue</span>
        </label>
      </div>

      <div className="settings-card" style={{ maxWidth: 720, marginTop: "1rem" }}>
        <div className="settings-card-header">
          <h3>Signup form fields</h3>
          <p>Show or hide optional fields on the public signup form.</p>
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer", fontWeight: 600 }}>
          <input
            type="checkbox"
            checked={genderField}
            onChange={(e) => setGenderField(e.target.checked)}
            disabled={!venue}
          />
          <span>Show the Gender field</span>
        </label>
        <p className="field-hint" style={{ marginTop: "0.35rem" }}>When off, the Gender dropdown is removed from the signup form and no gender is sent to the provider.</p>
      </div>

      <div className="settings-card" style={{ maxWidth: 720, marginTop: "1rem" }}>
        <div className="settings-card-header">
          <h3>Analytics &amp; conversion tracking</h3>
          <p>
            Optional. Fire your own Google Analytics 4 and/or Meta (Facebook) Pixel from the
            public signup — a page view on load and a conversion when a member completes signup.
            Leave blank to disable. <strong>Loads third-party trackers and sets cookies — you're
            responsible for your own cookie-consent notice.</strong>
          </p>
        </div>
        <div className="form-field" style={{ marginBottom: "0.75rem" }}>
          <label>GA4 Measurement ID</label>
          <input value={ga4} onChange={(e) => setGa4(e.target.value)} placeholder="G-XXXXXXXXXX" disabled={!venue} />
        </div>
        <div className="form-field">
          <label>Meta Pixel ID</label>
          <input value={pixel} onChange={(e) => setPixel(e.target.value)} placeholder="e.g. 123456789012345" disabled={!venue} />
        </div>
      </div>

      <div style={{ marginTop: "1rem", maxWidth: 720 }}>
        <button className="btn btn-primary" onClick={save} disabled={saving || !venue}>
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </ClientLayout>
  );
}
